import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAutoCase]'
})
export class AutoCaseDirective {
  @Input('appAutoCase') caseCode: number = 0;

  constructor(private el: ElementRef, @Optional() private control: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const inputEl = this.el.nativeElement as HTMLInputElement;
    let value = inputEl.value;
    if (!value) return;

    // Apply case transformation based on the provided case code
    switch (this.caseCode) {
      case 1: // Title Case
        value = value.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        break;
      case 2: // First letter capital only
        value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        break;
      case 3: // ALL CAPS
        value = value.toUpperCase();
        break;
      case 4: // all lowercase
        value = value.toLowerCase();
        break;
      default:
        return; // No transformation if unknown
    }

    // Preserve cursor position
    const start = inputEl.selectionStart;
    const end = inputEl.selectionEnd;

    inputEl.value = value;
    inputEl.setSelectionRange(start, end);

    // Update Angular control value silently
    if (this.control?.control) {
      this.control.control.setValue(value, { emitEvent: false });
    }
  }
}
